/**
 * Network normalization helper for withdrawal wallet matching.
 *
 * Maps all known BSC / BNB Smart Chain aliases to the canonical
 * database value 'BSC' so that wallet-network comparisons succeed
 * regardless of how the wallet was originally registered.
 *
 * SECURITY: This is a read-side normalizer only.
 * It does NOT change what is written to the database.
 */

const BSC_ALIASES = new Set([
  'bsc',
  'bnb',
  'bnb smart chain',
  'bsc (bnb smart chain)',
  'usdt-bep20',
  'usdt bep-20',
  'usdt bep20',
  'bep20',
  'bep-20',
  'bsc (bnb smart chain) \u2014 usdt bep-20',
  'bsc (bnb smart chain) - usdt bep-20',
]);

/**
 * Normalizes a network identifier to its canonical form.
 * All BSC-family aliases resolve to 'BSC'.
 * All other values are returned trimmed but unchanged.
 */
export function normalizeWithdrawalNetwork(value: string | null | undefined): string {
  if (!value) return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  const lower = trimmed.toLowerCase();
  if (BSC_ALIASES.has(lower)) return 'BSC';
  return trimmed;
}
